import { Injectable } from '@angular/core';
import { ShipmentQuery } from '../../../models/shipment-query';
import { FilterService } from './filter.service';

@Injectable({
    providedIn: 'root'
})
export class ShipmentFilterService extends FilterService<ShipmentQuery> {}
